/*
 * Akční popup — jednou na návštěvníka, zavřít křížkem, pozadím nebo Esc.
 *
 * Zapamatování řešíme localStorage, ne cookie: Safari maže cookie nastavené
 * skriptem po sedmi dnech, takže by se popup vracel lidem, kteří ho už viděli.
 */
(function () {
  'use strict';

  var popup = document.querySelector('[data-promo-popup]');
  if (!popup) return;

  var dialog = popup.querySelector('.tf-promo__dialog');
  var closeButton = popup.querySelector('.tf-promo__close');
  var pamet = popup.getAttribute('data-promo-key') || 'tf_promo';
  var prodleva = parseFloat(popup.getAttribute('data-promo-delay'));
  var puvodniFokus = null;
  var casovac = null;

  if (isNaN(prodleva) || prodleva < 0) prodleva = 4;

  // V editoru motivu chceme popup vidět pokaždé, jinak by se nedal nastavovat.
  var editorMotivu = !!(window.Shopify && window.Shopify.designMode);

  function jizVidel() {
    if (editorMotivu) return false;
    try {
      return window.localStorage.getItem(pamet) !== null;
    } catch (e) {
      // Soukromý režim může localStorage zakázat — pak popup radši neukazujeme
      // opakovaně a spolehneme se na to, že relace stejně dlouho netrvá.
      return false;
    }
  }

  function zapamatuj() {
    if (editorMotivu) return;
    try {
      window.localStorage.setItem(pamet, String(Date.now()));
    } catch (e) {
      /* nevadí, popup jen nebude zapamatovaný */
    }
  }

  function zavri() {
    if (popup.hidden) return;
    popup.hidden = true;
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('tf-promo-open');
    document.removeEventListener('keydown', naKlavesu, true);
    if (puvodniFokus && typeof puvodniFokus.focus === 'function') {
      puvodniFokus.focus();
    }
  }

  function naKlavesu(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      zavri();
      return;
    }
    // Uvnitř jsou jen dva ovládací prvky, tak držíme fokus mezi nimi.
    if (event.key === 'Tab') {
      var prvky = dialog.querySelectorAll('a[href], button:not([disabled])');
      if (!prvky.length) return;
      var prvni = prvky[0];
      var posledni = prvky[prvky.length - 1];
      if (event.shiftKey && document.activeElement === prvni) {
        event.preventDefault();
        posledni.focus();
      } else if (!event.shiftKey && document.activeElement === posledni) {
        event.preventDefault();
        prvni.focus();
      }
    }
  }

  function otevri() {
    if (jizVidel()) return;
    zapamatuj();
    puvodniFokus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('tf-promo-open');
    // Třída až v dalším snímku, ať se stihne spustit přechod.
    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.addEventListener('keydown', naKlavesu, true);
    if (closeButton) closeButton.focus();
  }

  popup.addEventListener('click', function (event) {
    if (event.target.closest('[data-promo-close]')) {
      event.preventDefault();
      zavri();
    }
  });

  // Proklik na akci bereme jako vyřízený popup — zavřeme, ať se odkaz otevře
  // na čistou stránku a popup po návratu zpátky nevyskočí.
  var odkaz = popup.querySelector('.tf-promo__link');
  if (odkaz) {
    odkaz.addEventListener('click', function () {
      zapamatuj();
      document.documentElement.classList.remove('tf-promo-open');
    });
  }

  if (jizVidel()) return;
  casovac = window.setTimeout(otevri, prodleva * 1000);

  // Když člověk odchází z okna dřív, než popup naskočí, neotravujeme ho.
  window.addEventListener('pagehide', function () {
    window.clearTimeout(casovac);
  });
})();
